/* eslint-env browser, node */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import feeCalculatorTotal from '../selectors/feeCalculatorTotal.selector';
import feeCalculatorDebitCardTotal from '../selectors/feeCalculatorDebitCardTotal.selector';
import feeCalculatorCreditCardTotal from '../selectors/feeCalculatorCreditCardTotal.selector';

class FeeCalculatorTotal extends Component {
  render() {
    const { cashTotal, debitCardTotal, creditCardTotal } = this.props;
    return (
      <div className="FeeCalculatorTotal">
        <span className="FeeCalculatorTotal-subheading">if paid by cash/check</span>
        <h2 className="FeeCalculatorTotal-text">TOTAL <span className="FeeCalculatorTotal-number">{cashTotal || '0.00'}</span></h2>

        <span className="FeeCalculatorTotal-subheading">if paid by debit card</span>
        <h2 className="FeeCalculatorTotal-text">TOTAL <span className="FeeCalculatorTotal-number">{debitCardTotal || '0.00'}</span></h2>

        <span className="FeeCalculatorTotal-subheading">if paid by credit card</span>
        <h2 className="FeeCalculatorTotal-text">TOTAL <span className="FeeCalculatorTotal-number">{creditCardTotal || '0.00'}</span></h2>

        <span className="FeeCalculatorTotal-note print-only">Note:  Transactions submitted by mail must be paid by Check or Certified Funds.</span>

        <span className="footnote print-only">* Fees and Totals contained herein are <em>estimations only</em> and are subject to change.</span>
        <button className="PrintBtn no-print" onClick={() => window.print()}>PRINT</button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cashTotal: feeCalculatorTotal(state),
    debitCardTotal: feeCalculatorDebitCardTotal(state),
    creditCardTotal: feeCalculatorCreditCardTotal(state),
  };
};

export default connect(mapStateToProps)(FeeCalculatorTotal);
